import { Suspense, useContext, lazy, Fragment } from "react";
import { useSelector } from "react-redux";
// ** Utils
import { isUserLoggedIn } from "@utils";
import { AbilityContext } from "../utility/context/Can";
// ** Custom components
import LayoutWrapper from "../layouts/LayoutWrapper";
import { useHistory } from "react-router-dom";
// ** Router components
import {
    BrowserRouter as AppRouter,
    Route,
    Switch,
    Redirect,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
// ** Routes & Default Routes
import { Routes, getDefoultRoute } from "./routes";
import Repository from "../configs/axios/repository";
// ** Layouts
import BlankLayout from "@layouts/BlankLayout";
import VerticalLayout from "@src/layouts/VerticalLayout";
import { store } from "../redux/store";
const Router = () => {
    // ** ACL Ability Context
    const ability = useContext(AbilityContext);
    const history = useHistory();
    // ** Default Layout
    const DefaultLayout = "VerticalLayout";
    const [defaultRoute, setDefaultRoute] = useState(null);
    // ** All of the available layouts
    const Layouts = { BlankLayout, VerticalLayout };
 
    // ** Current Active Item
    const currentActiveItem = null;
    const isState = useSelector((state) => {
        return state.auth.userData;
    });
    const role = store.getState().auth.userData;
    // ** Return Filtered Array of Routes & Paths
    const LayoutRoutesAndPaths = (layout) => {
        const LayoutRoutes = [];
        const LayoutPaths = [];

        if (Routes) {
            Routes.filter((route) => {
                // ** Checks if Route layout or Default layout matches current layout
                if (
                    route.layout === layout ||
                    (route.layout === undefined && DefaultLayout === layout)
                ) {
                    LayoutRoutes.push(route);
                    LayoutPaths.push(route.path);
                }
            });
        }

        return { LayoutRoutes, LayoutPaths };
    };
    // let userData = localStorage.getItem("userData");
    const NotAuthorized = lazy(() =>
        import("@src/views/pages/errors/notAuthorized")
    );

    // ** Init Error Component
    const Error = lazy(() => import("../views/pages/errors/error"));

    /**
     ** Final Route Component Checks for Login & User Role and then redirects to the route
     */
    const FinalRoute = (props) => {
        const route = props.route;
        let action, resource;
        // return <Redirect to="/invateUser?course_id=10&email=it.vahe.vardanyan+4@gmail.com&course_name=American%20history" />;
        // ** Assign vars based on route meta
        if (route.meta) {
            action = route.meta.action ? route.meta.action : null;
            resource = route.meta.resource ? route.meta.resource : null;
        }

        if (
            (!isUserLoggedIn() && route.meta === undefined) ||
            (!isUserLoggedIn() &&
                route.meta &&
                !route.meta.authRoute &&
                !route.meta.publicRoute)
        ) {
            /**
             ** If user is not Logged in & route meta is undefined
             ** OR
             ** If user is not Logged in & route.meta.authRoute, !route.meta.publicRoute are undefined
             ** Then redirect user to login
             */
            return <Redirect to="/login" />;
        } else if (route.meta && route.meta.authRoute && isUserLoggedIn()) {
            // ** If route has meta and authRole and user is Logged in then redirect user to home page (DefaultRoute)
            const queryParameters = new URLSearchParams(window.location.search);
            const course_id = queryParameters.get("course_id");
            const courseName = queryParameters.get("course_name");
            const emailNotDecoding = queryParameters.get("email");
            const email = decodeURIComponent(
                queryParameters.get("email")
            )?.replace(/ /g, "+");

            if (course_id != undefined) {
                return (
                    <Redirect
                        to={
                            emailNotDecoding
                                ? `/invateUser?course_id=${course_id}&email=${email}&course_name=${courseName}`
                                : `/invateUser?course_id=${course_id}&course_name=${courseName}`
                        }
                    />
                );
            } else {
                if (role.role == "instructor") {
                    return <Redirect to="/courses" />;
                } else {
                    return <Redirect to="/home" />;
                }
            }
        } else if (
            isUserLoggedIn() &&
            !ability.can(action || "read", resource)
        ) {
            return <Redirect to="/misc/not-authorized" />;
        } else {
            // ** If none of the above render component
            return <route.component {...props} />;
        }
    };

    // ** Return Route to Render
    const ResolveRoutes = () => {
        return Object.keys(Layouts).map((layout, index) => {
            // ** Convert Layout parameter to Layout Component
            // ? Note: make sure to keep layout and component name equal

            const LayoutTag = Layouts[layout];

            // ** Get Routes and Paths of the Layout
            const { LayoutRoutes, LayoutPaths } = LayoutRoutesAndPaths(layout);

            const routerProps = {};

            return (
                <Route path={LayoutPaths} key={index}>
                    <LayoutTag
                        layout="vertical"
                        setLayout={() => {}}
                        transition="fadeIn"
                        routerProps={routerProps}
                        setLastLayout={() => {}}
                        setTransition={() => {}}
                        currentActiveItem={currentActiveItem}
                    >
                        <Switch>
                            {LayoutRoutes.map((route) => {
                                return (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        exact={route.exact === true}
                                        render={(props) => {
                                            // ** Assign props to routerProps
                                            Object.assign(routerProps, {
                                                ...props,
                                                meta: route.meta,
                                            });

                                            return (
                                                <Fragment>
                                                    {/* Layout Wrapper to add classes based on route's layout, appLayout and className */}

                                                    {route.layout ===
                                                    "BlankLayout" ? (
                                                        <Fragment>
                                                            <FinalRoute
                                                                route={route}
                                                                {...props}
                                                            />
                                                        </Fragment>
                                                    ) : (
                                                        <LayoutWrapper
                                                            path={route.path}
                                                            layout={
                                                                DefaultLayout
                                                            }
                                                            transition="fadeIn"
                                                            setTransition={() => {}}
                                                            /* Conditional props */
                                                            /*eslint-disable */
                                                            {...(route.appLayout
                                                                ? {
                                                                      appLayout:
                                                                          route.appLayout,
                                                                  }
                                                                : {})}
                                                            {...(route.meta
                                                                ? {
                                                                      routeMeta:
                                                                          route.meta,
                                                                  }
                                                                : {})}
                                                            {...(route.className
                                                                ? {
                                                                      wrapperClass:
                                                                          route.className,
                                                                  }
                                                                : {})}
                                                            /*eslint-enable */
                                                        >
                                                            <Suspense
                                                                fallback={null}
                                                            >
                                                                <FinalRoute
                                                                    route={
                                                                        route
                                                                    }
                                                                    {...props}
                                                                />
                                                            </Suspense>
                                                        </LayoutWrapper>
                                                    )}
                                                </Fragment>
                                            );
                                        }}
                                    />
                                );
                            })}
                        </Switch>
                    </LayoutTag>
                </Route>
            );
        });
    };
    useEffect(async () => {
        let path = getDefoultRoute(isState.access_token);
        setDefaultRoute(path);
    }, [isState.access_token]);

    if (defaultRoute == "") {
        return "";
    }

    function checkRole() {
        if (role.role == "instructor") {
            return <Redirect to="/courses" />;
        } else {
            return <Redirect to={defaultRoute} />;
        }
    }
    return defaultRoute != null ? (
        <AppRouter basename={process.env.REACT_APP_BASENAME}>
            <Switch>
                {/* If user is logged in Redirect user to DefaultRoute else to login */}
                <Route
                    exact
                    path="/"
                    render={() => {
                        return isUserLoggedIn() ? (
                            checkRole()
                        ) : (
                            <Redirect to="/login" />
                        );
                    }}
                />
                {/* Not Auth Route */}
                <Route
                    exact
                    path="/misc/not-authorized"
                    render={() => (
                        <Layouts.BlankLayout>
                            <NotAuthorized />
                        </Layouts.BlankLayout>
                    )}
                />
                {ResolveRoutes()}

                {/* NotFound Error page */}
                <Route path="*" component={Error} />
            </Switch>
        </AppRouter>
    ) : (
        ""
    );
};

export default Router;
